import { render, staticRenderFns } from "./PersonOrgDetailsUserInfoEve.vue?vue&type=template&id=7d3b960a&"
import script from "./PersonOrgDetailsUserInfoEve.vue?vue&type=script&lang=js&"
export * from "./PersonOrgDetailsUserInfoEve.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports